document.addEventListener("DOMContentLoaded", () => {
  // 针对每个 section 初始化轮播
  document.querySelectorAll('.kickstarter-slideshow').forEach((section, index) => {
    // Init Slick
    function initSlider(el) {
      if (!el.hasClass('slick-initialized')) {
        el.slick({
          infinite: true,
          draggable: true,
          centerMode: el.data('centermode') || true,
          centerPadding: el.attr('data-center-padding') || 'clamp(50px, 29.67vw, 712px)',
          slidesToShow: parseInt(el.attr('data-pc-slidestoshow')) || 1,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 5000,
          arrows: true,
          prevArrow: `<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="kickstarter-slideshow-prev-${index}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="kickstarter-slideshow-prev-${index}">Prev Item</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>`,
          nextArrow: `<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="kickstarter-slideshow-next-${index}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="kickstarter-slideshow-next-${index}">Next Item</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>`,
          dots: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
      } else {
        el.slick('refresh');
      }
    }

    initSlider($(section.querySelector('.kickstarter-slideshow-list')));

    // IntersectionObserver 控制自动轮播
    // const observer = new IntersectionObserver(entries => {
    //   entries.forEach(entry => {
    //     if (entry.isIntersecting) {
    //       let parentEl = entry.target;
    //       // Init Slider
    //       initSlider($(parentEl.querySelector('.kickstarter-slideshow-list')));
    //       observer.unobserve(parentEl); // 只执行一次
    //     }
    //   });
    // }, { threshold: 0.3 });

    // observer.observe(section);
  });
});